module.exports = __webpack_public_path__ + "img/banner-3k.be7be777.svg";